// extracted by mini-css-extract-plugin
export default {"root_SiteLocation":"Site_root_SiteLocation__3yqqu","info_location":"Site_info_location__QuP7t"};